import { naturalCompare } from "../helpers";
import { IDir, ISortMode } from "../types";

type ChangeString = (a: string) => string | number;

export class Sort {
	sort(array: any[], by: ISortMode, perm?: ISortMode) {
		this._createSorter(by);

		if (perm === by) by = null;
		if (perm || by) this._sort(array, perm, by);
	}
	private _createSorter(by?: ISortMode) {
		if (by && !by.rule) {
			by.rule = (a: any, b: any) => {
				const aa = this._checkVal(by.as, a[by.by]);
				const bb = this._checkVal(by.as, b[by.by]);
				// [TODO] why we need naturalCompare
				return naturalCompare(aa.toString(), bb.toString());
			};
		}
	}
	private _checkVal(method: ChangeString, val: string | number) {
		return method ? method.call(this, val) : val;
	}
	private _sort(arr: any[], conf: ISortMode, conf2: ISortMode): any[] {
		const dir: IDir = {
			asc: 1,
			desc: -1,
		};
		return arr.sort((a: any, b: any) => {
			let t = 0;
			if (conf) t = conf.rule.call(this, a, b) * (dir[conf.dir] || dir.asc);
			if (t === 0 && conf2) t = conf2.rule.call(this, a, b) * (dir[conf2.dir] || dir.asc);
			return t;
		});
	}
}
